<template>
  <v-container class="pt-4">
    <div v-if="!overlay">
      <div v-if="!examQuestionRes.exam.isDone">
        <v-row>
          <v-col cols="12" md="12">
            <v-card class="d-flex align-center rounded-lg pa-2 px-4" flat>
              <h4 class="" v-if="!isStart">
                {{
                  examQuestionRes.exam
                    ? `${examQuestionRes.exam.title} - ${examQuestionRes.exam.subjectName}`
                    : ""
                }}
              </h4>
              <v-spacer></v-spacer>
              <v-btn tile color="primary" @click="back()" class="rounded-xl">
                {{ $t("back") }}
                <v-icon right> mdi-arrow-left </v-icon>
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="!isStart">
          <v-col cols="12" md="9" sm="12">
            <v-card class="align-center rounded-lg pa-2 px-4" flat>
              <ShowQuestion
                ref="childComponent"
                :Question="currentQuestion"
                :ExamGuid="id"
                :IsEnd="isEnd"
                v-on:send-result-values="nextQuestion"
                :key="activeQuestion"
              ></ShowQuestion>
            </v-card>
          </v-col>
          <v-col cols="12" md="3" sm="12">
            <v-card class="align-center rounded-lg py-4 px-0" flat dark>
              <Timer
                :starttime="starttime"
                :endtime="endtime"
                :trans="trans"
                :nowDate="examQuestionRes.exam.currentServerDatetime"
                v-on:send-result-values="back"
              ></Timer>
            </v-card>

            <v-card class="align-center rounded-lg mt-3 pa-6" flat>
              <v-row>
                <v-col
                  cols="12"
                  md="3"
                  sm="3"
                  xs="3"
                  class="pa-1"
                  v-for="(item, index) in examQuestionRes.exam.examQuestions"
                  :key="index"
                >
                  <v-btn
                    @click="showQuestion(item, index)"
                    :elevation="activeQuestion == index ? 3 : 0"
                    :rounded="activeQuestion == index"
                    block
                    class=""
                    :outlined="!item.studentAnswers[0] ? true : false"
                    dark
                    color='primary'
                    :title="item.question.trim()"
                  >
                    {{ index + 1 }}
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-if="isInRole(0)" class="mt-10"
                ><v-col cols="12">
                  <v-btn
                    width="100%"
                    @click="doneTheExam"
                    outlined
                    dark
                    color="red"
                  >
                    {{ $t("exam.FinishTheExam") }}
                  </v-btn>
                </v-col></v-row
              >
            </v-card>

            <v-card
              v-if="examQuestionRes.exam.description"
              class="align-center rounded-lg mt-3"
            >
              <v-card-text dir="auto" style="white-space: pre-line !important">
                {{ examQuestionRes.exam.description.trim() }}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="isStart">
          <v-col class="text-center pt-10">
            <img src="../../assets/document.svg" width="200px" />
            <h3>{{ $t("exam.TheExamHasNotStartedYet") }}</h3>
          </v-col>
        </v-row>
      </div>
      <div v-else>
        <v-row>
          <v-col class="text-center pt-10">
            <img src="../../assets/complete.png"  />
            <h3>{{ $t("exam.AnswerSubmitted") }}</h3>
            <v-btn class="mt-5" dark depressed to="/"> {{ $t("back") }} </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-container>
</template>

<script>
import Timer from "../../components/exams/timer.vue";
import ShowQuestion from "../../components/exams/showQuestion.vue";
export default {
  components: {
    Timer,
    ShowQuestion,
  },
  props: ["id"],
  data() {
    return {
      isStart: false,
      isEnd: false,
      activeQuestion: -1,
      overlay: false,
      examQuestionRes: null,
      starttime: new Date(),
      endtime: new Date(),
      currentQuestion: {},
      trans: {
        day: this.$t("exam.day"),
        hours: this.$t("exam.hours"),
        minutes: this.$t("exam.minutes"),
        seconds: this.$t("exam.seconds"),
        expired: this.$t("exam.expired"),
        running: this.$t("exam.running"),
        upcoming: this.$t("exam.upcoming"),
        status: {
          expired: this.$t("exam.status.expired"),
          running: this.$t("exam.status.running"),
          upcoming: this.$t("exam.status.upcoming"),
        },
      },
    };
  },
  methods: {
    showQuestion(questionInfo, index) {
      this.isEnd = index == this.examQuestionRes.exam.examQuestions.length - 1;
      this.activeQuestion = index;
      // console.log(this.activeQuestion);
      this.currentQuestion = questionInfo;
      //  this.$refs.childComponent.setValue(questionInfo, this.id, this.isEnd);
    },
    nextQuestion(studentAnswer) {
      var question = this.examQuestionRes.exam.examQuestions.filter(
        (obj) => obj.questionGuid === studentAnswer.questionGuid
      );
      if (question && question.length > 0) {
        question[0].studentAnswers = studentAnswer.answer.map((obj) => {
          return { answerText: obj };
        });
      } else {
        this.getQuestions();
      }

      if (this.isEnd) {
        this.getQuestions();
        // this.back()
      } else {
        this.activeQuestion = this.activeQuestion + 1;
      }
      // this.getQuestions();
      this.showQuestion(
        this.examQuestionRes.exam.examQuestions[this.activeQuestion],
        this.activeQuestion
      );
    },
    getQuestions() {
      this.isStart = false;
      this.overlay = true;

      var url = `Exams/GetQuestions?ExamGuid=${this.id}`;
      if (this.isInRole(0)) {
        url += `&StudentGuid=${this.getUserInfo().guid}`;
      }

      this.axios
        .get(url)
        .then((res) => {
          // console.log(res);
          if (res.data.data) {
            this.examQuestionRes = res.data.data;
            //console.log(this.examQuestionRes.exam.examQuestions);
            this.starttime = this.examQuestionRes.exam.startDate;
            this.endtime = this.examQuestionRes.exam.endDate;
            setTimeout(() => {
              this.activeQuestion = 0;
              this.showQuestion(
                this.examQuestionRes.exam.examQuestions[this.activeQuestion],
                this.activeQuestion
              );
            }, 100);
          } else {
            this.isStart = true;
          }
        })
        .catch(() => {
          this.back();
          this.$swal.fire({
            title: this.$t("AnErrorOccurredDuringTheProcess"),
            text: "",
            icon: "error",
            confirmButtonText: this.$t("close"),
          });
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    enterToExam() {
      if (!this.isInRole(0)) {
        return;
      }
      this.axios
        .post(`Exams/EnterExam?ExamGuid=${this.id}`)
        .then((res) => {})
        .catch(() => {})
        .finally(() => {});
    },
    doneTheExam() {
      if (!this.isInRole(0)) {
        return;
      }

      this.$swal
        .fire({
          title: this.$t("AreYouSureAboutTheOperation"),
          text: "",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("yes"),
          cancelButtonText: this.$t("no"),
        })
        .then((result) => {
          if (result.value) {
            this.axios
              .put(`Exams/DoneExam?ExamGuid=${this.id}`)
              .then((res) => {
                this.getQuestions();
              })
              .catch(() => {
                this.$swal.fire({
                  title: this.$t("AnErrorOccurredDuringTheProcess"),
                  text: "",
                  icon: "error",
                  confirmButtonText: this.$t("close"),
                });
              })
              .finally(() => {});
          }
        });
    },
    back() {
      this.$router.go(-1);
    },
  },
  created() {
    //this.enterToExam();
    this.getQuestions();
  },
};
</script>

<style lang="scss" scoped>
.v-btn:not(.v-btn--round).v-size--default {
  min-width: 5px;
}
</style>
